import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsightSubtlety = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32.0001 27.0012",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 13.0012L16 26.0012M9.99993 22.0012H10.0499M22.9999 25.0012H23.0499M18.9999 3.00117H19.0499M31 7.49324C22.4457 5.05212 15.2221 12.0822 16.0675 20.0012C28.337 19.5009 25.7192 11.1146 31 7.49324ZM1.00004 1.16467C10.6893 -0.30825 17.649 8.42775 15.6591 17.0012C2.29964 14.7212 6.292 5.88475 1.00004 1.16467Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgInsightSubtlety;
